import React, { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Copy, CopyCheck } from 'lucide-react';

import { Button } from '../ui/button';
import { showMessage } from '../Utils';
import { RootState } from '../../types/redux';

interface OwnProps {
  url?: string;
}

const mapStateToProps = (state: RootState) => ({
  isMobile: state.browser.lessThan.medium,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & OwnProps;

const ShareBtn: React.FC<Props> = ({ isMobile, url }) => {
  const [copied, setCopied] = useState(false);

  const targetUrl = url ?? window.location.href;

  const onClick = async () => {
    await navigator.clipboard.writeText(targetUrl);
    setCopied(true);
    showMessage.info('已複製網址到剪貼簿！');
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <Button
      size="sm"
      variant="outline"
      onClick={onClick}
      className="text-blue-600 hover:text-blue-700"
    >
      {copied ? <CopyCheck className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
      {!isMobile && <span className="ml-2">複製網址</span>}
    </Button>
  );
};

// @ts-ignore - TypeScript issue with React 18 and react-redux types
export default connector(ShareBtn) as React.ComponentType<OwnProps>;